import type { ModernSubscription } from '../../types';
import { SubscriptionStates } from '../../types';

export function isExpiredTrialWithNoPlan(modernSubscription: ModernSubscription) {
  const { state: subscriptionState } = modernSubscription;
  const state = subscriptionState ?? SubscriptionStates.UNKNOWN;
  return [SubscriptionStates.GRACE_PERIOD_TRIAL, SubscriptionStates.LAPSED_TRIAL].includes(state as SubscriptionStates);
}
